$(document).on('click', 'a[data-clickable-placeholder]', function(e) {
  var editor_id, placeholder;
  e.preventDefault();
  editor_id = e.target.getAttribute('data-clickable-placeholder');
  placeholder = e.target.textContent;
  return $("#" + editor_id).get(0).editor.insertString(placeholder);
});
